(function(){
  // Cart drawer
  var drawer = document.querySelector('[data-drawer]');
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-drawer-open]')){ if(drawer) drawer.setAttribute('open',''); }
    if(e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__scrim')){ if(drawer) drawer.removeAttribute('open'); }
  });

  // PDP variant selection
  document.querySelectorAll('[data-product]').forEach(function(root){
    var dataEl = root.querySelector('[data-variants]');
    if(!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc]');
    var groups = root.querySelectorAll('[data-opt-group]');
    var selected = [];
    groups.forEach(function(g,i){
      var first = g.querySelector('.opt__btn');
      selected[i] = first ? first.getAttribute('data-value') : null;
      if(first) first.classList.add('on');
    });
    function money(cents){ try{ return (cents/100).toLocaleString(undefined,{style:'currency',currency:root.getAttribute('data-currency')||'EUR'}); }catch(e){ return (cents/100).toFixed(2); } }
    function match(){
      return variants.find(function(v){
        return selected.every(function(val,i){ return !val || v['option'+(i+1)]===val; });
      });
    }
    function update(){
      var v = match();
      if(v){
        if(idInput) idInput.value = v.id;
        if(priceEl) priceEl.firstChild ? priceEl.firstChild.nodeValue = money(v.price) : priceEl.textContent = money(v.price);
        if(atc){ atc.disabled = !v.available; atc.textContent = v.available ? (atc.getAttribute('data-label')||'In den Warenkorb') : 'Ausverkauft'; }
      } else if(atc){ atc.disabled = true; atc.textContent = 'Nicht verfügbar'; }
    }
    groups.forEach(function(g,i){
      g.querySelectorAll('.opt__btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          selected[i] = btn.getAttribute('data-value');
          g.querySelectorAll('.opt__btn').forEach(function(b){ b.classList.remove('on'); });
          btn.classList.add('on');
          update();
        });
      });
    });
    update();

    // Gallery thumbs
    var main = root.querySelector('[data-gallery-main]');
    root.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        if(main) main.src = t.getAttribute('data-full');
        root.querySelectorAll('[data-thumb]').forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  });

  // Shipping countdown to a cutoff hour
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var cutoff = parseInt(el.getAttribute('data-countdown'),10) || 17;
    function tick(){
      var now = new Date();
      var end = new Date(); end.setHours(cutoff,0,0,0);
      if(end < now) end.setDate(end.getDate()+1);
      var d = Math.max(0, end - now);
      var h = Math.floor(d/3.6e6), m = Math.floor(d%3.6e6/6e4), s = Math.floor(d%6e4/1e3);
      el.textContent = (h<10?'0':'')+h+'h '+(m<10?'0':'')+m+'m '+(s<10?'0':'')+s+'s';
    }
    tick(); setInterval(tick,1000);
  });

  // Dynamic shipping/delivery dates (today + offset), German DD.MM.
  (function(){
    function fmt(d){ return ('0'+d.getDate()).slice(-2)+'.'+('0'+(d.getMonth()+1)).slice(-2)+'.'; }
    document.querySelectorAll('[data-date-offset]').forEach(function(el){
      var off = parseInt(el.getAttribute('data-date-offset'),10)||0;
      var d = new Date(); d.setDate(d.getDate()+off);
      el.textContent = fmt(d);
    });
  })();
})();
